import { useApi, createApiHook } from "../utils/apiUtils";

const useUpdateAspect = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { error, startLoading, setResponse } = useApiState();

  const updateAspect = async ({ id, external_id, name, description } = {}) => {
    if (!id) return false;

    const body = {};
    if (typeof external_id !== "undefined") body.external_id = external_id;
    if (typeof name !== "undefined") body.name = name;
    if (typeof description !== "undefined") body.description = description;

    if (Object.keys(body).length === 0) {
      setResponse({ message: "Sin cambios, no se envío información" });
      return true;
    }

    startLoading();
    const response = await apiPatch(`/aspects/${id}`, "Error al actualizar el aspecto", body);
    setResponse(response);
    return !response?.error;
  };

  return { updateAspect, error };
};

export default useUpdateAspect;
